import * as a from '../actionsTypes/actionTypes';

const INITIAL_STATE = {
  locais: [],
  processandoLocal: false,
  localById: null,
};

export default (state = INITIAL_STATE, action) => {
  const { type, payload } = action;

  switch (type) {
    case a.LOC_SET_ESTADO_INICIAL:
      return { ...state, processandoLocal: false, locais: [] };
    case a.LOC_GET_LOCAIS:
      return { ...state, locais: payload };
    case a.LOC_PROCESSANDO_LOCAL:
      return { ...state, processandoLocal: payload };
    case a.LOC_GET_LOCAL_BY_ID:
      return { ...state, localById: payload };
    default:
      return { ...state };
  }
};
